import React from 'react';
import MaterialUIBreadcrumbs from '@material-ui/core/Breadcrumbs';
import { useLocation } from 'react-router-dom';
import {
  Typography,
  Box,
  Theme,
  makeStyles,
  createStyles,
} from '@material-ui/core';
import { getBreadcrumbLabel } from 'helpers/navigation';

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    container: {
      paddingBottom: theme.spacing(4),
    },
  });
});

const Breadcrumbs: React.FC<{}> = () => {
  const { pathname } = useLocation();
  const label = getBreadcrumbLabel(pathname);
  const labels = label.split('/');
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <MaterialUIBreadcrumbs aria-label='breadcrumb'>
        {labels.map((item, index) => (
          <Typography
            key={item}
            variant='h6'
            color={
              index === labels.length - 1 ? 'textPrimary' : 'textSecondary'
            }
          >
            {item}
          </Typography>
        ))}
      </MaterialUIBreadcrumbs>
    </Box>
  );
};

export default Breadcrumbs;
